import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'
import PropTypes from 'prop-types'
import c from 'classnames'
import { fromAddress } from 'react-geocode'
import { setUserAddress } from '../../reducers/user'
import { updateClaim } from '../../reducers/claim'
import {
  CONFIRM_ADDRESS_PATH,
  GOOGLE_API_GEOCODE_DEBOUNCE_TIMER,
} from '../../constants'
import { selectFormattedUserAddress } from '../../selectors/user'

const handleAddressError = (err) => {
  const { message, type } = err
  if (type === 'validation') {
    const { address } = message
    const fields = Object.keys(address)
    return `Please complete a full address '${fields.join(', ')}' ${fields.length > 1 ? 'are' : 'is'} missing`
  }
  return message
}

export function ConfirmAddress({ className }) {
  const [addressSuggestions, setAddresSuggestions] = useState([])
  const [address, setAddress] = useState(
    useSelector(selectFormattedUserAddress)
  )
  const [addressError, setAddressError] = useState('')
  const dispatch = useDispatch()

  const update = useCallback(
    debounce((currentAddress) => {
      fromAddress(currentAddress)
        .then(({ results }) => {
          setAddresSuggestions(results)
        })
        .catch(() => {
          setAddresSuggestions([])
        })
    }, GOOGLE_API_GEOCODE_DEBOUNCE_TIMER),
    []
  )

  const onChangeAddress = (e) => {
    const newAddress = e.target.value
    setAddress(newAddress)
    update(newAddress)
    if (!isEmpty(addressError)) {
      setAddressError('')
    }
  }
  const onSelectAddress = (placeId) => {
    const fullData = addressSuggestions.find((add) => add.place_id === placeId)
    setAddress(fullData.formatted_address)
    setAddresSuggestions([])
    const userAddressDetail = fullData.address_components.reduce(
      (acc, component) => {
        if (component.types.includes('street_number')) {
          acc.street_number = component.long_name
        } else if (component.types.includes('route')) {
          acc.street = component.long_name
        } else if (component.types.includes('locality')) {
          acc.city = component.long_name
        } else if (component.types.includes('administrative_area_level_1')) {
          acc.state = component.long_name
        } else if (component.types.includes('country')) {
          acc.country = component.long_name
        } else if (component.types.includes('postal_code')) {
          acc.zip = component.long_name
        }
        return acc
      },
      {}
    )
    dispatch(setUserAddress(userAddressDetail))
    dispatch(
      updateClaim({ section: CONFIRM_ADDRESS_PATH, preventPopupError: true })
    )
      .unwrap()
      .then((res) => {})
      .catch((err) => {
        const message = handleAddressError(err)
        setAddressError(message)
      })
  }

  return (
    <div className={c('confirm-address', className)}>
      <label className="form-label small soft">STREET ADDRESS</label>
      <input
        type="text"
        onChange={onChangeAddress}
        className="form-control confirm-address_input"
        name="address"
        placeholder="Enter your Address"
        value={address}
      />
      {!isEmpty(addressSuggestions) && (
        <div className="confirm-address_opt-container">
          <div className="confirm-address_options">
            {addressSuggestions.map((r) => (
              <button
                key={r.place_id}
                type="button"
                className="confirm-address_option"
                onClick={() => onSelectAddress(r.place_id)}
              >
                {r.formatted_address}
              </button>
            ))}
          </div>
        </div>
      )}
      {!isEmpty(addressError) && (
        <div className="error-text">{addressError}</div>
      )}
    </div>
  )
}
export default ConfirmAddress

ConfirmAddress.propTypes = {
  className: PropTypes.string,
}

ConfirmAddress.defaultProps = {
  className: '',
}
